import { IMyBeckhoffService } from './types';

export const getMyBeckhoffService = (): IMyBeckhoffService => {
  if (window.myBeckhoff) {
    return window.myBeckhoff;
  } else {
    throw new Error('MyBeckhoffService not present!');
  }
};
